/* eslint-disable */
export default {
  dial: 'Dial',
  message: 'Message',
  transfer: 'Transfer',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
